export type TAppConfig = {
  msal: {
    clientId: string;
    authority: string;
  };
  api: {
    baseUrl: string;
  };
  app: {
    version: string;
  }
};

export type TAppConfigWindow = Window & {
  pipelineConfig: TAppConfig;
};

const w = window as unknown as TAppConfigWindow;

export const appConfig: TAppConfig = {
  msal: {
    clientId: import.meta.env.VITE_APP_CLIENTID ?? w.pipelineConfig?.msal.clientId,
    authority: import.meta.env.VITE_APP_AUTHORITY ?? w.pipelineConfig?.msal.authority,
  },
  api: {
    baseUrl: import.meta.env.VITE_APP_BASE_URL ?? w.pipelineConfig?.api.baseUrl,
  },
  app: {
    version: import.meta.env.VITE_APP_VERSION ?? w.pipelineConfig?.app.version,
  }
};
